import React, { useCallback } from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import { IOffer } from '@rbi-ctg/menu';
import { IOfferFeedbackEntryFragment } from 'generated/rbi-graphql';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { useOffer } from '../use-offer';

import { CellLayout } from './cell-layout';

interface IOfferCellProps extends IBaseProps {
  offer: IOffer;
  offerFeedback: IOfferFeedbackEntryFragment | null;
  onClick: (offerId: string) => void;
  isSelected: boolean;
  favorited?: boolean;
  favoriteEnabled?: boolean;
  favoriteLoading?: boolean;
  handleToggleFavorite?: (sanityId: string, name: string) => void;
}

export const OfferCell: React.FC<IOfferCellProps> = ({
  className = '',
  offer,
  offerFeedback,
  onClick,
  isSelected,
  favorited = false,
  favoriteEnabled = false,
  favoriteLoading = false,
  handleToggleFavorite,
}) => {
  const { endingIn, platforms, displayLoginRequiredBadge } = useOffer({
    offer,
    offerFeedback,
  });

  const onClickOffer = useCallback(() => {
    onClick(offer._id);
  }, [offer, onClick]);
  const enableOfferBadges = useFlag(LaunchDarklyFlag.ENABLE_OFFER_BADGES);

  return (
    <CellLayout
      className={className}
      offer={offer}
      onClick={onClickOffer}
      isSelected={isSelected}
      redeemable
      enableOfferBadges={enableOfferBadges}
      endingIn={endingIn}
      platforms={platforms}
      displayLoginRequiredBadge={displayLoginRequiredBadge}
      favorited={favorited}
      favoriteEnabled={favoriteEnabled}
      favoriteLoading={favoriteLoading}
      handleToggleFavorite={handleToggleFavorite}
    />
  );
};
